import '../css/progressBar.css';
import { useEffect, useState, memo } from "react";
import WaveformVisualizer from "./WaveformVisualizer";

const ProgressBar = memo(({ audioEnv, rawData, duration }) => {
    const [progress, setProgress] = useState(0);

    // Seek Audio
    const handleSeek = (e) => {
        const newTime = parseFloat(e.target.value);
        if (audioEnv) {
            audioEnv.getAudioElement().currentTime = newTime;
            setProgress(newTime);
        }
    };
    
    useEffect(() => {
        let animationFrameId;
    
        const updateProgress = () => {
            if (audioEnv) {
                setProgress(audioEnv.getAudioElement().currentTime);
                animationFrameId = requestAnimationFrame(updateProgress);
            }
        };
    
        // Start the progress updates
        updateProgress();
    
        // Cleanup function to stop the updates when the component unmounts
        return () => {
            if (animationFrameId) {
                cancelAnimationFrame(animationFrameId);
            }
        };
    }, [audioEnv]);

    return (
        <div className='progress-bar-container container'>
            <WaveformVisualizer rawData={rawData} />
            <input
                type="range"
                min="0"
                max={duration}
                step="0.1"
                value={progress}
                onChange={handleSeek}
                className="progress-bar"
            />
        </div>

    )
});

export default ProgressBar